import React, { useEffect, useState } from "react";
import axiosInstance from "../../api";
import Pagination from "../Homepage/Pagination";
import { useNavigate } from "react-router-dom";
import GenerateReport from "./GenerateReport";
import GeneratePerformanceReport from "./GeneratePerformanceReport";

function Technicians() {
  const [page, setpage] = useState(1);
  const [pages, setpages] = useState(0);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [performanceData, setPerformanceData] = useState([]);
  const navigate = useNavigate();
  const [username, setusername] = useState(0);
  const [showpopup, setshowpopup] = useState(false);
  const [showPerformancePopup, setShowPerformancePopup] = useState(false);
  const [payload, setPayload] = useState({
    Duration: "",
    FromDate: "",
    ToDate: "",
    Type: "",
  });

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/User/GetAllTechnicianUsers/${page}`
      )
      .then((res) => {
        setData(res.data?.data);
        setpages(res.data?.pages);
        setTotal(res.data?.count);
      })
      .catch(console.log);
  }, [page]);

  return (
    <div>
      <h1>Technicians</h1>
      <p>Total: {total}</p>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
              <blockquote>
                <p>Username</p>
              </blockquote>
              <blockquote>
                <p>Vouchers Made</p>
              </blockquote>
              <blockquote>
                <p>Tickets Closed</p>
              </blockquote>
              <blockquote>
                <p>Reports Generated</p>
              </blockquote>
              <blockquote>
                <p>Locations Visited</p>
              </blockquote>
              <blockquote>
                <p>Site Contact Details Added</p>
              </blockquote>
              <blockquote>
                <p>Actions</p>
              </blockquote>
            </aside>
          </div>
          <div>
            {data?.map((x, i) => (
              <aside key={i} style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
                <blockquote>
                  <p>{x.user}</p>
                </blockquote>
                <blockquote
                  onClick={() => {
                    navigate(`/dashboard/technician/vouchers?search=${x.user}`);
                  }}
                >
                  <p>{x.vouchers}</p>
                </blockquote>
                <blockquote>
                  <p>{x.tickets}</p>
                </blockquote>
                <blockquote
                  onClick={() => {
                    navigate(`/dashboard/technician/reports?search=${x.user}`);
                  }}
                >
                  <p>{x.reports}</p>
                </blockquote>
                <blockquote>
                  <p>{x.locationHistory}</p>
                </blockquote>
                <blockquote>
                  <p>{x.siteContacts}</p>
                </blockquote>

                <blockquote
                  onClick={() => {
                    setusername(x.user);
                    setshowpopup(true);
                  }}
                >
                  <i className="fa-solid fa-note-sticky" />
                </blockquote>
              </aside>
            ))}
          </div>
        </section>
      </section>
      <Pagination count={pages} setpagenumber={setpage} pagenumber={page} />
      {showpopup && (
        <GenerateReport
          username={username}
          close={setshowpopup}
          payload={payload}
          setPayload={setPayload}
          setPerformanceData={setPerformanceData}
          setShowPerformancePopup={setShowPerformancePopup}
        />
      )}
      {showPerformancePopup && (
        <GeneratePerformanceReport
          payload={payload}
          data={performanceData}
          username={username}
          setData={setPerformanceData}
          setShowPerformancePopup={setShowPerformancePopup}
        />
      )}
    </div>
  );
}

export default Technicians;
